import React from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { useQuery } from "@apollo/react-hooks";
import { Icons } from "@sellout/ui";
import { media } from "@sellout/ui/build/utils/MediaQuery";
import { BackstageState } from "../redux/store";
import * as AppActions from "../redux/actions/app.actions";
import { ModalTypes } from "../components/modal/Modal";
import { Page } from "../components/PageLayout";
import PageLoader from "../components/PageLoader";
import FilterButton from "../elements/FilterButton";
import GuestListTable from "../components/GuestListTable";
import EVENT_GUEST_LIST from "@sellout/models/.dist/graphql/queries/eventGuestList.query";

/************************************************************
 * Styled Components
 ************************************************************/

const SearchContainer = styled.div`
  margin: 0px 24px 24px 0px;
  display: flex;
  justify-content: flex-end;
  ${media.mobile`
   display: block;
  `};
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 15px;
  ${media.mobile`
  flex-direction: row;
  flex-flow: wrap;
`}
`;

const TableContainer = styled.div`
  display: flex;
  height: calc(100% - 74px);
  ${media.mobile`
  height: calc(100% - 160px);
`};
`;

/************************************************************
 * EventGuestList page
 ************************************************************/

type EventGuestListProps = {};

const EventGuestList: React.FC<EventGuestListProps> = () => {
  const dispatch = useDispatch();

  /** State */
  const eventState = useSelector((state: BackstageState) => state.event);
  const { eventId } = eventState;

  /** GraphQL */
  const { data, loading, refetch } = useQuery(EVENT_GUEST_LIST, {
    variables: {
      eventId,
    },
    fetchPolicy: "network-only",
  });

  const event = data?.event;

  /** Handlers */
  const openAddGuestModal = () => {
    dispatch(AppActions.pushModal(ModalTypes.AddGuestModal));
  };

  /** Render */
  return (
    <>
      <PageLoader nav sideNav fade={Boolean(event)} />
      <Page>
        <SearchContainer>
          <ButtonContainer>
            <FilterButton
              text="Add Guest"
              icon={Icons.Plus}
              onClick={openAddGuestModal}
            />
          </ButtonContainer>
        </SearchContainer>
        {event && (
          <TableContainer>
            <GuestListTable
              guestList={event?.guestList ?? []}
              event={event}
              refetch={refetch}
              loading={loading}
            />
          </TableContainer>
        )}
      </Page>
    </>
  );
};

export default EventGuestList;

